import React, { useState, useEffect } from "react";
import AdminTopbar from "../../component/AdminTopbar";
import axios from "axios";
import { baseurl, imageUrl } from "../../Baseurl";
import { Edit2, Trash2, Filter } from "react-feather";
import { useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';

function AllAssignee() {
  const adminID = localStorage.getItem("adminID");
  const [assignees, setAssignees] = useState([]);
  const [filteredAssignees, setFilteredAssignees] = useState([]);
  const [filters, setFilters] = useState({
    fullName: "",
    email: "",
    role: "",
    department: ""
  });
  const navigate = useNavigate();

  useEffect(() => {
    if (adminID) {
      fetchAssignees(adminID);
    }
  }, [adminID]);

  const fetchAssignees = async (adminId) => {
    try {
      const response = await axios.get(`${baseurl}getAssigneesByOrgId/${adminId}`);
      setAssignees(response.data.assignees || []);
      setFilteredAssignees(response.data.assignees || []);
    } catch (error) {
      console.error("Error fetching assignees:", error);
    }
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: "This action cannot be undone!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!',
    });
  
    if (result.isConfirmed) {
      try {
        await axios.delete(`${baseurl}deleteAssignee/${id}`);
        setAssignees(assignees.filter((a) => a.id !== id));
        setFilteredAssignees(filteredAssignees.filter((a) => a.id !== id));
        Swal.fire('Deleted!', 'Assignee has been deleted.', 'success');
      } catch (error) {
        console.error("Error deleting assignee:", error);
        Swal.fire('Error!', 'Failed to delete assignee.', 'error');
      }
    }
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const filterAssignees = () => {
    const { fullName, email, role, department } = filters;
    const filtered = assignees.filter(assignee => {
      return (
        (fullName ? assignee.full_name.toLowerCase().includes(fullName.toLowerCase()) : true) &&
        (email ? assignee.email.toLowerCase().includes(email.toLowerCase()) : true) &&
        (role ? assignee.role.toLowerCase().includes(role.toLowerCase()) : true) &&
        (department ? assignee.department.toLowerCase().includes(department.toLowerCase()) : true)
      );
    });
    setFilteredAssignees(filtered);
  };

  useEffect(() => {
    filterAssignees();
  }, [filters]);

  return (
    <>
      <AdminTopbar />
      <div className="container mt-4">
        <div className="d-flex justify-content-between align-items-center mb-2">
          <h2 className="chart-title text-start">All Users</h2>
          <div className="d-flex align-items-center">
            <Filter className="me-3" />
             
          </div>
        </div>

        {/* Filters Section */}
        <div className="d-flex mb-3">
          <input
            type="text"
            name="fullName"
            value={filters.fullName}
            onChange={handleFilterChange}
            placeholder="Filter by Full Name"
            className="form-control me-2 form-control-filter"
          />
          <input
            type="text"
            name="email"
            value={filters.email}
            onChange={handleFilterChange}
            placeholder="Filter by Email"
            className="form-control me-2 form-control-filter"
          />
          <input
            type="text"
            name="role"
            value={filters.role}
            onChange={handleFilterChange}
            placeholder="Filter by Role"
            className="form-control me-2 form-control-filter"
          />
          <input
            type="text"
            name="department"
            value={filters.department}
            onChange={handleFilterChange}
            placeholder="Filter by Department"
            className="form-control form-control-filter"
          />
        </div>

        {/* Table to display Assignees */}
        <div className="table-responsive">
          <table className="custom-table">
            <thead className="table-light">
              <tr>
                <th scope="col">#</th>
                <th scope="col">Profile</th>
                <th scope="col">Full Name</th>
                <th scope="col">Email</th>
                <th scope="col">Role</th>
                <th scope="col">Department</th>
                <th scope="col" className="text-center">Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredAssignees.length > 0 ? (
                filteredAssignees.map((item, index) => (
                  <tr key={item.id}>
                    <td>{index + 1}</td>
                    <td>
                      {item.profile_image ? (
                        <img
                          src={`${imageUrl}assignee/${item.profile_image}`}
                          alt="profile"
                          className="rounded-circle assignee-img"
                        />
                      ) : (
                        <div
                          className="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center assignee-img"
                          style={{ width: '40px', height: '40px', fontWeight: 'bold' }}
                        >
                          {item.full_name?.charAt(0).toUpperCase()}
                        </div>
                      )}
                    </td>
                    <td className="fw-semibold">{item.full_name}</td>
                    <td>{item.email}</td>
                    <td className="text-capitalize">{item.role}</td>
                    <td className="text-capitalize">{item.department}</td>
                    <td className="text-center">
                      <button
                        className="btn btn-sm btn-outline-danger me-2"
                        onClick={() => handleDelete(item.id)}
                      >
                        <Trash2 size={16} />
                      </button>

                      <button
                        className="btn btn-sm btn-outline-primary me-2"
                        onClick={() => navigate(`/edit-assignee/${item.id}`)}
                      >
                        <Edit2 size={16} />
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="text-center text-muted fst-italic py-3">
                    No assignees found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}

export default AllAssignee;
